import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../App'
import Chart from './chart'

export function useAppContextChart(viewKey: string): Chart | undefined {
    const appContext = useContext(AppContext)
    const [chart, setChart] = useState<Chart | undefined>(() => {
        const existing = viewKey ? appContext.getChart(viewKey) : undefined
        return existing?.chartApi ? existing : undefined
    })

    useEffect(() => {
        if (!viewKey) {
            setChart(undefined)
            return
        }

        let cancelled = false

        const attachChart = () => {
            if (cancelled) return
            const nextChart = appContext.getChart(viewKey)
            if (nextChart?.chartApi) {
                setChart(nextChart)
                return
            }
            requestAnimationFrame(attachChart)
        }

        setChart(undefined)
        attachChart()

        return () => {
            cancelled = true
        }
    }, [appContext, viewKey])

    return chart
}
